import { render, staticRenderFns } from "./coupon-pkgdata-view.vue?vue&type=template&id=dc908280&scoped=true"
import script from "./coupon-pkgdata-view.vue?vue&type=script&lang=js"
export * from "./coupon-pkgdata-view.vue?vue&type=script&lang=js"
import style0 from "./coupon-pkgdata-view.vue?vue&type=style&index=0&id=dc908280&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc908280",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc908280')) {
      api.createRecord('dc908280', component.options)
    } else {
      api.reload('dc908280', component.options)
    }
    module.hot.accept("./coupon-pkgdata-view.vue?vue&type=template&id=dc908280&scoped=true", function () {
      api.rerender('dc908280', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/components/coupon/coupon-pkgdata-view.vue"
export default component.exports